import Storage from "../storage/Storage";
import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";

const blindGuardianAPI = process.env.REACT_APP_BLIND_GUARDIAN_API;

export default class UserService {
    static async createUser(email: string): Promise<{ id: string }> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        let path = `/v1/p/users/${email}`;

        const url = blindGuardianAPI + path;
        const resp = await AxiosService.httpPost(url, config);
        return resp.data;
    }
}
